import React, {useEffect, useRef, useState} from 'react';
import s from './styles.module.css'
import Header from "./header";
import classNames from "classnames";
import InputBox from "./input_box";
import CheckIcon from '@mui/icons-material/Check';
import CloseIcon from '@mui/icons-material/Close';
import {Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, Tooltip} from "@mui/material";

const Brigade = ({data, headerData, setData, successBrigade}) => {
    const [openModal, setOpenModal] = useState(false);

    const [oldUser, setOldUser] = useState(0);
    const selectedRef = useRef(null);
    const containerRef = useRef(null);

    useEffect(() => {
        const container = containerRef.current;
        const element = selectedRef.current;

        if (!container || !element) return;

        setTimeout(() => {
            const containerRect = container.getBoundingClientRect();
            const elementRect = element.getBoundingClientRect();

            let offset = elementRect.top - containerRect.top + container.scrollTop;

            offset -= 60;

            container.scrollTo({
                top: offset,
                behavior: 'smooth'
            });
        }, 300);
    }, [data?.users?.find(f => f?.is_mark)?.user_id]);

    const current_sportsmen = data?.users?.find(f => f?.is_mark)
    return (
        <div className={s.main}>
            <Dialog
                fullWidth={true}
                open={openModal}
                onClose={() => setOpenModal(false)}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
            >
                <DialogTitle id="alert-dialog-title">
                    Подтверждение
                </DialogTitle>
                <DialogContent>
                    <DialogContentText id="alert-dialog-description">
                        Вы уверены, что хотите подтвердить ввод данных ?
                    </DialogContentText>
                </DialogContent>
                <DialogActions>
                    <Button variant={'outlined'} color={'error'} onClick={() => setOpenModal(false)}>
                        <CloseIcon sx={{fontSize: 40}}/>
                    </Button>
                    <Button variant={'contained'} onClick={async () => {
                        await successBrigade()
                        setOpenModal(false)
                    }} autoFocus>
                        <CheckIcon sx={{fontSize: 40}}/>
                    </Button>
                </DialogActions>
            </Dialog>
            <Header
                data={data}
                setData={setData} current_sportsmen={current_sportsmen}
                disabled={data?.users?.length === 0 || !data} headerData={headerData}
                openModal={() => setOpenModal(true)}
            />

            <div className={s.content}>
                <div className={s.figure_box}>

                    <div className={s.figure_box_jud}>
                        <div className={s.figure_box_header_title} style={{
                            minWidth: '60px',
                            maxWidth: '60px'
                        }}>Ст
                        </div>
                        <div className={s.figure_box_header_title} style={{
                            minWidth: '199px',
                            maxWidth: '199px'
                        }}>ФИО
                        </div>
                        <div className={s.figure_box_header_title} style={{
                            minWidth: '63px',
                            maxWidth: '63px'
                        }}>г.р
                        </div>
                        <div className={s.figure_box_header_title}
                             style={{
                                 minWidth: '194px',
                                 maxWidth: '194px'
                             }}>Команда
                        </div>
                        <div className={s.figure_box_header_title} style={{
                            minWidth: '52px',
                        }}>Jd 1
                        </div>
                        <div className={s.figure_box_header_title} style={{
                            minWidth: '52px',
                        }}>Jd 2
                        </div>
                        <div className={s.figure_box_header_title} style={{
                            minWidth: '52px',
                        }}>Jd 3
                        </div>
                        <div className={s.figure_box_header_title} style={{
                            minWidth: '52px',
                        }}>Jd 4
                        </div>
                        <div className={s.figure_box_header_title} style={{
                            minWidth: '52px',
                        }}>Jd 5
                        </div>
                        <div className={s.figure_box_header_title} style={{
                            minWidth: '52px',
                        }}>Jd 6
                        </div>
                        <div className={s.figure_box_header_title} style={{
                            minWidth: '52px',
                        }}>Jd 7
                        </div>
                        <div className={s.figure_box_header_title} style={{
                            minWidth: '93px',
                            maxWidth: '93px'
                        }}>Total
                        </div>
                    </div>

                    <div ref={containerRef} className={s.figure_box_jud_2}>
                        {data?.users?.sort((a, b) => a?.sort - b?.sort)?.map((el, index) => {
                            return <div key={el?.user_id} ref={el?.is_mark === 1 ? selectedRef : null}
                                        className={classNames(s.figure_box_jud, s.figure_box_jud_title)}>
                                <Tooltip
                                    title={el?.is_not_started === 1 ? 'DNS' : el?.is_disqulified === 1 ? 'DSQ' : ''}
                                    placement="right"
                                    sx={{
                                        tooltip: {
                                            backgroundColor: '#333',
                                            color: '#fff',
                                            fontSize: '14px',
                                            padding: '1px 1px',
                                            borderRadius: '4px',
                                        },
                                    }}
                                >
                                    <div
                                        className={s.figure_box_header_title}
                                        style={{
                                            minWidth: '60px',
                                            maxWidth: '60px',
                                            alignItems: 'center',
                                            justifyContent: 'center',
                                            textAlign: 'center',
                                            background:
                                                el?.is_mark === 1
                                                    ? '#86B760'
                                                    : el?.is_not_started === 1 || el?.is_disqulified === 1
                                                        ? 'rgba(255,0,0,.3)'
                                                        : '#FFF',
                                            color: el?.is_mark === 1 ? '#FFF' : undefined,
                                        }}
                                    >
                                        {el.draw}
                                    </div>
                                </Tooltip>
                                <div className={s.figure_box_header_title}
                                     style={{
                                         minWidth: '199px',
                                         maxWidth: '199px'
                                     }}>{el.user_name}
                                </div>
                                <div className={s.figure_box_header_title} style={{
                                    minWidth: '63px',
                                    maxWidth: '63px'
                                }}>{el?.year || 1975}
                                </div>
                                <div className={s.figure_box_header_title}
                                     style={{
                                         minWidth: '194px',
                                         maxWidth: '194px'
                                     }}>{el.user_command}
                                </div>
                                {[1, 2, 3, 4, 5, 6, 7].map((scor, inx) => {
                                    const score = el?.scores.find((f) => +f.number_coach === +scor)
                                    return <InputBox disabled={score === undefined}
                                                     is_read={el?.is_disqulified === 1 || el?.is_not_started === 1}
                                                     setData={setData} data={data} index_box={index} key={scor}
                                                     score={score} user_id={el?.user_id} value={score?.value}
                                                     id={score?.score_figure_id}
                                                     oldUser={oldUser}
                                                     setOldUser={setOldUser}
                                    />
                                })}
                                <div className={s.figure_box_header_title}
                                     style={{
                                         minWidth: '93px',
                                         maxWidth: '93px',
                                         minHeight: '34px'
                                     }}>
                                    {el?.result_figure ? (+el?.result_figure)?.toFixed(4) : ''}
                                </div>
                            </div>
                        })}
                    </div>
                </div>
            </div>
        </div>
    )
        ;
};

export default Brigade;
